import type { RegionId } from '../sim/data/oceans';
import { SITES, type SiteId } from '../sim/data/sites';
import type { Sanctuary, World } from '../sim/types';
import { epochDayOf } from '../sim/calendar';
import { sanctuaryEnvironment } from '../sim/systems/environment';

/**
 * What the aquarium shows (M98, the brief's world map): the player's sanctuary, or a site of the seven the world
 * map visits. A visited site is not run by the player and holds nothing the simulation does not: its seafloor its
 * own where built, its water, its light and its sea's departure its region's (the simulation's, stepped every day),
 * its sun its own latitude's; no coral, no fish, no whales, no plankton of its own (the region's plankton stands for it).
 * Changes nothing in the world; pure, tested in node (`tests/worldMap.test.ts`).
 */
export type Place = Pick<Sanctuary, 'siteId' | 'regionId' | 'site' | 'env' | 'coral' | 'fish' | 'plankton' | 'whales' | 'turtles' | 'seals' | 'sharks' | 'slope'> & { name: string; visiting: boolean };

/** A site of the seven as the aquarium shows it on the world's date. */
export function visitPlace(world: World, siteId: SiteId): Place {
  const def = SITES[siteId];
  const region = world.regions.find((r) => r.id === def.regionId);
  if (!region) throw new Error(`no region ${def.regionId}`);
  const env = sanctuaryEnvironment({ site: def.site, siteId, regionId: def.regionId as RegionId, sst: region.sst }, epochDayOf(world));
  return { name: def.name, siteId, regionId: def.regionId, site: def.site, env, coral: null, fish: null, plankton: null, whales: null, turtles: null, seals: null, sharks: null, slope: null, visiting: true };
}

/** The player's own sanctuary as a place, or the site visited. */
export function shownPlace(world: World, visiting: SiteId | null): Place | undefined {
  const own = world.sanctuaries[0];
  if (visiting !== null && visiting !== own?.siteId) return visitPlace(world, visiting);
  return own ? { ...own, visiting: false } : undefined;
}
